import { flowItems } from "@/mocks/jiuse";

export default function Timeline() {
  return (
    <section id="timeline" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex scroll-mt-24 flex-col gap-3 border-b-2 border-foreground-950 pb-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-1 flex items-center gap-2 text-xs font-semibold tracking-[0.26em] text-primary-700">
              <i className="ri-history-line text-sm" aria-hidden="true" />
              截帧 · 原图流出
            </p>
            <h2 className="font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">九色黑料截图原图，持续流出记录</h2>
          </div>
          <p className="flex items-center gap-2 whitespace-nowrap text-[13px] text-foreground-600">
            <i className="ri-restart-line text-accent-600" aria-hidden="true" /> 最近更新 · 09月06日 11:20
          </p>
        </div>

        <div className="mt-8 space-y-0">
          {flowItems.map((it, idx) => (
            <article key={idx} className="group relative flex cursor-pointer gap-4 pb-5 md:gap-7 md:pb-6">
              {/* 时间轴轨道 */}
              <div className="flex flex-col items-center">
                <span className="relative z-10 grid h-4 w-4 place-items-center">
                  <span className="h-2.5 w-2.5 rounded-full bg-primary-600 transition group-hover:bg-accent-600" aria-hidden="true" />
                </span>
                {idx < flowItems.length - 1 && <span className="mt-1 w-px flex-1 bg-background-300" aria-hidden="true" />}
              </div>

              <div className="min-w-0 flex-1 border-b border-background-200 pb-5 group-last:border-b-0 md:pb-6">
                <div className="mb-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[12px]">
                  <span className="whitespace-nowrap font-semibold text-foreground-800">{it.date} · {it.time}</span>
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-900">{it.label}</span>
                </div>
                <h3 className="font-display text-[16px] font-bold leading-snug text-foreground-950 transition group-hover:text-primary-700">
                  <a href="#timeline">{it.title}</a>
                </h3>
                <p className="mt-1.5 text-[13px] leading-6 text-foreground-600">{it.note}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}